import angular from 'angular'

import createLoanRequestFromLoanEnquiryModule from './createLoanRequestFromLoanEnquiry/createLoanRequestFromLoanEnquiry'
import assessmentComponent from './assessment.component.js'

export default angular.module('app.pages.admin.loanEnquiryDetails.assessment', [createLoanRequestFromLoanEnquiryModule.name])
  .directive('adminLoanEnquiryDetailsAssessment', assessmentComponent)
